import {defineStyle} from '@chakra-ui/styled-system';

import {defineGraphCSSVars} from './helpers';

const {
  gap: $gap,
  border: $border,
  boxShadow: $boxShadow,
} = defineGraphCSSVars(`controls`, [`gap`, `border`, `boxShadow`]);

// Those are defined on the top level component
export const controlsCssVars = {
  [$gap.variable]: `space.16`,
  [$border.variable]: `borders.none`,
  [$boxShadow.variable]: `shadows.none`,
};

export const controlsStyle = defineStyle(({orientation}) => ({
  [`&.react-flow__controls`]: {
    gap: $gap.reference,
    display: `flex`,
    border: $border.reference,
    boxShadow: $boxShadow.reference,
    flexDirection: orientation === `horizontal` ? `row` : `column`,
    // We are rendering the controls inside another reactflow panel to achieve positioning
    position: `relative`,
    margin: `0`,
  },
}));
